import Button from "@/shared/form/button";
import { useTranslations } from "use-intl";
import { useCopingToOtherLanguages } from "@/shared/html-template-editor/copy-to-others-languages-button/model/use-coping-to-other-languages";

type CopyToOthersLanguagesButtonProps = {
  activeLanguage?: string;
  name: string | string[];
};

export default function CopyToOthersLanguagesButton({
  activeLanguage,
  name,
}: CopyToOthersLanguagesButtonProps) {
  const t = useTranslations("OpenHtmlTemplateEditorButton");
  const { copy } = useCopingToOtherLanguages(name, activeLanguage);

  return <Button onClick={copy}>{t("Copy to others languages")}</Button>;
}
